export const projects = [
  {
    title: "Hybrid Project",
    subtitle: "Azure Migrate, Azure DevOps, Azure App Service, Azure Securities, Azure Functions, Windows Server, AD, AVD, Entra ID, M365 Admin, Entra, Intune, AD connect, Hyper-V Manager.",
    description:
      "An innovative hybrid project seamlessly integrating on-premise infrastructure with the power of Azure.",
    image: "./project-23.png",
    link: "",
    github: "https://github.com/koushik80/hybrid-infra-azure-intern-project",
  },
  {
    title: "ÇąƒÉ ŎŁđįęş-Quiz App",
    subtitle: "React, CSS, Fort Awesome, React Router Dom, Firebase-auth, Firebase Database.",
    description:
      "A full-stack Music Quiz App with video link.",
    image: "./project-20.gif",
    link: "https://quiz-app-dev.netlify.app/",
    github: "https://github.com/koushik80/react-quiz-app.git",
  },
  {
    title: "ßLIZZARD-Accelerate the excitement",
    subtitle: "Tech Stack: HTML, CSS, Bootstrap, Material Design, JavaScript, Python:Django, PostgreSQL",
    description:
      "A real-world full-stack web app for the car dealers.",
    image: "./project-19.gif",
    link: "https://blizzard-car.herokuapp.com/",
    github: "https://github.com/koushik80/blizzard-django.git",
  },
  {
    title: "Ci†yßîke App",
    subtitle: "React, RTK Query, SASS, Mapbox GL, MUI, Yup, React Router Dom, Node, Express, Mongoose, chai, mocha, enzyme, enzyme-adapter-react-16, react-test-renderer",
    description:
      "A full-stack MERN app to display data from journeys made with city bikes in the Helsinki capital area. This app also displays maps and distances of routes.",
    image: "./project-21.gif",
    link: "https://city-bike.onrender.com/",
    github: "https://github.com/koushik80/city-bike",
  },
  {
    title: "Rﾐ-₩ﾖAR",
    subtitle: "Tech Stack: React, Firebase, Material-UI, Stripe API, commerce.js.",
    description:
      "Rﾐ-₩ﾖAR app allows users to save the recycled products in the cart, add to cart/Remove from cart (the +/- feature)...",
    image: "./project-3.gif",
    link: "https://rewear.netlify.app/",
    github: "https://github.com/koushik80/re-wear.git",
  },
  {
    title: "NAVANA",
    subtitle: "Tech Stack: HTML,CSS,PHP,MySQL",
    description:
      "NAVANA web app allows buyers from the concept & design phase to sampling and all the way through the production process, shipping process and provides a complete end-to-end manufacturing service.",
    image: "./project-1x.gif",
    link: "https://koushikd.azurewebsites.net/",
    github: "https://github.com/koushik80/Navana_PHP_FEATURED.git",
  },
  {
    title: "Delivery-Fee-Calculator",
    subtitle: "Tech Stack: React, CSS, TypeScript, fort-awesome, enzyme",
    description:
      "An app which calculates a delivery fee based on user input and shows the calculated delivery fee to the user.",
    image: "./project-22.gif",
    link: "https://delivery-fee-calc.netlify.app/",
    github: "https://github.com/koushik80/delivery-fee-calculator",
  },
  {
    title: "devHuß Job Listing App",
    subtitle: "Tech Stack: React,Sass styling",
    description:
      "Advanced Conditional Rendering, Filter data based on the categories selected, Getting JSON data from file and displaying it.",
    image: "./project-6.gif",
    link: "https://joblist-koushik.netlify.app/",
    github: "https://github.com/koushik80/job-list.git",
  },
  {
    title: "devHuß Job Portal",
    subtitle: "Tech Stack: React,CSS, Chart, Material-UI.",
    description:
      "React job panel dashboard using React Hooks and functional components.",
    image: "./project-7.gif",
    link: "https://job-portal-koushik.netlify.app/",
    github: "https://github.com/koushik80/job-portal.git",
  },
  {
    title: "ƑINƑO†EK",
    subtitle: "Tech Stack: Python, JS, Flask & SQLite.",
    description:
      "ƑINƑO†EK web app helps businesses improve their performance and implement changes that optimize process in order to achieve success. It breaks down different aspects of a client's financial life including...",
    image: "./project-2.gif",
    link: "https://finfotek.herokuapp.com/",
    github: "https://github.com/koushik80/Finfotek_Flask_App.git",
  },
  {
    title: "devHuß (MERN application)",
    subtitle: "Tech Stack: React.js, Node.js, Axios, MongoDB, Nodemon, timeago.js, Socket.io.",
    description:
      "A real-world app for the developers(Under development...)",
    image: "./project-5.gif",
    link: "https://devhub-frontend-koushik.netlify.app/",
    github: "https://github.com/koushik80/devhub_koushik_social_ui.git",
  },
  {
    title: "devHuß wiki",
    subtitle: "Tech Stack: React.js, Node.js, Next js, Passport js, auth-0, Axios, MongoDB, Nodemon, Bootstrap.",
    description:
      "View existing articles posted by other users, Require user to be logged in to write a new article and to edit an existing article.",
    image: "./project-8.gif",
    link: "https://devhub-forum.herokuapp.com",
    github: "https://github.com/koushik80/devhub-wiki.git",
  },
  {
  title: "devHuß travel-map",
    subtitle: "Tech Stack: React.js, Node.js, React Hook, Bcrypt, Moment, Axios, MongoDB, Nodemon, Mapbox, Express.",
    description:
      "Full-stack map travel app using Mapbox.Feature : Pin location, share reviews with other users, registration and login.",
    image: "./project-9.gif",
    link: "",
    github: "https://github.com/koushik80/travel-map.git",
  },
  {
  title: "Droppe Xmas",
    subtitle: "Tech Stack: React, Sass, React Hook, React-router-dom, axios, Material UI, Font Awesome.",
    description:
      "Xmas online marketplace",
    image: "./project-15.gif",
    link: "https://droppe-xmas-koushik.netlify.app/",
    github: "https://github.com/koushik80/droppe-xmas-assign.git",
  },
  {
  title: "Bar Chart",
    subtitle: "HTML, CSS, JavaScript, D3 svg-based visualization library.",
    description:
      "freeCodeCamp Data Visualization Project-1",
    image: "./project-18.png",
    link: "https://fcc-p1-bar-chart.netlify.app/",
    github: "https://github.com/koushik80/bar-chart.git",
  },
  {
  title: "DOM Project",
    subtitle: "HTML, CSS, JavaScript",
    description:
      "Project to show different applications of DOM.",
    image: "./project-16.gif",
    link: "https://hack-programming-hero-ko.netlify.app/",
    github: "https://github.com/koushik80/hack-programming-hero.git",
  },
  {
  title: "GitHuß Search Engine",
    subtitle: "React, Semantic UI, Fort-awesome",
    description:
      "App to displays expected GitHub user's name, account, followers, repos, following and image.",
    image: "./project-17.gif",
    link: "https://ghub-search-engine.netlify.app/",
    github: "https://github.com/koushik80/git-repo-display.git",
  },
  {
  title: "25 + 5 Clock",
    subtitle: "Tech Stack: React, CSS, React Hook",
    description:
      "freeCodeCamp Frontend Development Certification Project-5.",
    image: "./project-14.gif",
    link: "https://codepen.io/koushikdey/full/mdpYdGR",
    github: "https://github.com/koushik80/fcc-clock.git",
  },
  {
  title: "JS Calculator",
    subtitle: "Tech Stack: HTML, CSS, JavaScript",
    description:
      "freeCodeCamp Frontend Development Certification Project-4.",
    image: "./project-13.gif",
    link: "https://js-calculator-koushik.netlify.app/",
    github: "https://github.com/koushik80/js-calculator.git",
  },
  {
  title: "Drum Machine",
    subtitle: "Tech Stack: React, CSS, React Hook",
    description:
      "freeCodeCamp Frontend Development Certification Project-3.",
    image: "./project-12.gif",
    link: "https://drum-machine-koushik.netlify.app/",
    github: "https://github.com/koushik80/drum-machine.git",
  },
  {
  title: "Markdown Previewer",
    subtitle: "Tech Stack: HTML, CSS, Bootstrap, JavaScript.",
    description:
      "freeCodeCamp Frontend Development Certification Project-2.",
    image: "./project-11.gif",
    link: "https://markdown-previewer-koushik.netlify.app/",
    github: "https://github.com/koushik80/Markdown-Previewer_fcc_frontend-project-2.git",
  },
  {
  title: "Random Quote Machine",
    subtitle: "Tech Stack: HTML, CSS, Bootstrap, JavaScript.",
    description:
      "freeCodeCamp Frontend Development Certification Project-1.",
    image: "./project-10.gif",
    link: "https://random-quote-machine-koushik.netlify.app/",
    github: "https://github.com/koushik80/Random-Quote-Machine.git",
  }
];

export const testimonials = [
  {
    quote:
      "I'm really getting excited by your works-eye appealing, not to mention how great it looks! I have recommended you strongly to a friend of mine who needs a website for his properties business.",
    image: "./t3.jpg",
    name: "Jenny Oksanen, Fleet & Sustainability Manager",
    company: "Volvo Car, Finland",
  },
  {
    quote:
      "I just wanted to take a moment to say how pleased I am with your projects. I believe that Koushik work very hard, and with a truly dedicated and conscientious spirit rarely found.Maybe not everyone appreciates your efforts often enough, but I wanted to extend to you how much I appreciate your work and concern for your projects over these past few months.",
    image: "./mamun.png",
    name: "Shah Mamun, Service Operations Engineer",
    company: "Vodafone, UK",
  },
  {
    quote:
      "Wow! Your website looks amazing, the best yet as a beginner. So colourful and professional and eyecatching. It is very impressive what you have done. Would happily recommend them to anyone thinking about either getting a website or refreshing an existing one.",
    image: "./rumon.png",
    name: "Aktarul Ahsan, Deputy Director",
    company: "Geological Survey, Bangladesh",
  },
];

export const skills = [
  "Cloud, DevOps & Web Servers:  Azure (Administration, Azure Networking, Azure Virtual Desktop, Azure DevOps), AWS EBS, Git, Nginx, apache2, Skaffold, CI/CD, Docker & Kubernetes, Ansible, Heroku, Netlify.",
  "Virtualization: Proxmox, VirtualBox, Hyper-V.",
  "Scripting: PowerShell, Bash.",
  "Server, Security & Administration: Windows Server, Active Directory, GPO, Microsoft 365 Admin(Endpoint), Linux, Azure Security Technologies, pfSense, Cybersecurity(Cisco).",
  "Template Engine: Jinja.",
  "Hardware & Network Management: Configuration & Installation, Troubleshooting, Communication Devices Setup, Network Management, AMS, Technical Support.",
  "Programming Languages: JavaScript, Python.",
  "Frontend: HTML, CSS, Bootstrap, Material-UI, Styled Components, ReactJS, TypeScript, Context API, AJAX, SASS, Redux.",
  "Backend & Authentication: NodeJS, Express, JWT, Flask, Django.",
  "API Development & Testing: REST, Axios, Postman.",
  "Database: MySQL, PostgreSQL, Firebase, MongoDB.",
  "Payment Gateway Integration: Stripe.",
  "Testing: Jest, React Testing Library, Cypress.",
  "Data Management & Visualization: Data Visualization with D3, Python-Pandas, Python-NumPy.",
  "Tools, Version Control & Migration: VS Code, GitHub, Yarn, npm, APT & Azure Migration.",
];